const colors = {
    primary: '#3E49DE', 
    primaryLight: '#2E69D1',
    secondary: '#FFA903', 
    textMain: '#F8F8F8',
    textLink: '#FFF',
    parrafos: '#0D0D0D',
    parrafoLight: '#FFFAFA',
    error: '#C13050',
    primaryDegradado: '#6A78E4',
    bgLight: '#F8FFFF',
    bgPrimaryLight: '#6A88E8',
    bgCircularProgressUnfinished: '#9EBCD6',
    bgDarkLight: '#E0E0E0',
    bgDifferenceUp: '#DDFEDD',
    bgDifferenceMedium: '#D4FBFE',
    bgDifferenceDown: '#FEDADA',
    underLine: '#DDD',
    blueGradient: '#C8CBFF',
    darkDisable: '#a6a6a6'
}

export default colors;
